/**
 * Share links people paste instead of a direct file link: turn them into a link that returns
 * the image itself. Other URLs are returned unchanged.
 */
export function directImageUrl(raw: string): string {
  let url: URL;
  try {
    url = new URL(raw.trim());
  } catch {
    return raw;
  }
  const host = url.hostname.replace(/^www\./, '');
  // Google Drive: /file/d/<id>/view, /open?id=<id>, /uc?id=<id>
  if (host === 'drive.google.com' || host === 'docs.google.com') {
    const id =
      /\/file\/d\/([\w-]{10,})/.exec(url.pathname)?.[1] ??
      (url.pathname === '/open' || url.pathname === '/uc' ? url.searchParams.get('id') : null);
    if (id) return `https://drive.google.com/uc?export=download&id=${id}`;
  }
  // Dropbox: ?dl=0 opens a preview page; raw=1 returns the file
  if (host === 'dropbox.com' && /^\/(s|scl)\//.test(url.pathname)) {
    url.searchParams.delete('dl');
    url.searchParams.set('raw', '1');
    return url.toString();
  }
  // GitHub file pages → raw content
  if (host === 'github.com') {
    const m = /^\/([^/]+)\/([^/]+)\/blob\/(.+)$/.exec(url.pathname);
    if (m) return `https://raw.githubusercontent.com/${m[1]}/${m[2]}/${m[3]}`;
  }
  return url.toString();
}
